<template>
  <div>
    <div class="main-content-container container-fluid px-4">
      <div>
        <div class="page-header row no-gutters py-4">
          <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
            <span class="text-uppercase page-subtitle">Proyectos</span>
            <h3 class="page-title">Agregar proyecto</h3>
          </div>
        </div>

        <select-image @selected="setImage" :error="error.image.message[0]"/>

        <div class="row">
          <div class="col-lg-9 col-md-12">
            <div class="card card-small mb-3">
              <div class="card-body">
                <div class="form-group">
                  <input placeholder="Nombre" class="form-control" :class="error.name.status" v-model="form.name"/>
                  <div class="invalid-feedback">
                    {{ error.name.message[0] }}
                  </div>
                </div>
                <div class="form-group">
                  <input placeholder="SLUG" class="form-control" v-model="slug" readonly/>
                </div>
                <div class="form-group">
                  <textarea class="form-control" :class="error.excerpt.status" rows="5" placeholder="Descripción" v-model="form.excerpt"></textarea>
                  <div class="invalid-feedback">
                    {{ error.name.message[0] }}
                  </div>
                </div>
              </div>
              <div class="alert alert-primary" role="alert" v-if="error.body.status">
                {{ error.body.message[0] }}
              </div>   
            </div>
          </div>
          <div class="col-lg-3 col-md-12">
            <div class='card card-small mb-3'>
              <div class="card-header border-bottom">
                <h6 class="m-0">Acciones</h6>
              </div>

              <div class='card-body p-0'>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex px-3">
                    <button class="btn btn-sm btn-accent" @click="save()">
                      <i class="fas fa-upload"></i>
                      Actualizar
                    </button>
                  </li>
                </ul>
              </div>

            </div>
            <select-category @selected="setCategory" :error="error.category.message[0]"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage';
  import SelectImage from '@/components/dashboard/post/add/SelectImage.vue'
  import SelectCategory from '@/components/dashboard/post/add/SelectCategory.vue'
  import { VueEditor } from 'vue2-editor'
  export default {
    components: { NotificationMessage, SelectImage, SelectCategory, VueEditor },

    data() {
      return {
      	project: '',
        customToolbar: [
          [{ 'header': [1, 2, 3, 4, false] }],
          ['bold', 'italic', 'underline'],
          [{ 'color': [] }, { 'background': [] }], 
          [{ 'align': [] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ],
        form: {
          image: '',
          name: '',
          excerpt: '',
          category: '',
        },
        error: {
          image: {
            status: '',
            message: ''
          },
          name: {
            status: '',
            message: ''
          },
          excerpt: {
            status: '',
            message: ''
          },
          body: {
            status: '',
            message: ''
          },
          category: {
            status: '',
            message: ''
          }
        }
      }
    },

    computed: {
      slug() {
        return this.form.name.toLowerCase().split(' ').join('_')
      },
      param() {
      	return this.$route.params.slug;
      }
    },

    mounted() {
    	this.getProject();
    },

    methods: {
    	async getProject() {
    		let url = process.env.VUE_APP_ROOT_API.concat(`/project/${this.param}`);
    		let response = await fetch(url);
    		this.project = await response.json();
    		if(response.status == 200) {
    			this.form.name = this.project.name;
    			this.form.excerpt = this.project.excerpt;
          this.form.category = this.project.category_id;
    		}
    	},

      setImage(data) {
        this.form.image = data;
      },

      setCategory(data) {
        this.form.category = data;
      },

      cleanErrors() {
        this.error.image.status = '';
        this.error.image.message = '';

        this.error.name.status = '';
        this.error.name.message = '';

        this.error.excerpt.status = '';
        this.error.excerpt.message = '';

        this.error.category.status = '';
        this.error.category.message = '';
      },

      async save() {
        this.cleanErrors();

        let url;
        let formData = new FormData();
        formData.append('user_id', this.$store.state.auth.user.id);
        formData.append('image', this.form.image);
        formData.append('name', this.form.name);
        formData.append('slug', this.slug);
        formData.append('excerpt', this.form.excerpt);
        formData.append('category_id', this.form.category);

        if(this.form.image) {
        	url = process.env.VUE_APP_ROOT_API.concat(`/project/${this.project.id}`);
        }else {
        	url = process.env.VUE_APP_ROOT_API.concat(`/project/partially/${this.project.id}`);
        }

        let settings = {
          method: 'POST',
          body: formData
        };

        let response = await fetch(url, settings);
        
        switch (response.status) {
          case 200:
            this.success();
            break;
          case 422:
            this.handlerError(response);
            break;
        }
      },

      success() {
        this.$router.replace('/proyectos');
        this.$toasted.show("<i class='fas fa-handshake'></i> Proyecto editado!", { 
          theme: "toasted-primary", 
          position: "top-right", 
          duration : 2000
        });
      },

      async handlerError(response) {
        let error = await response.json();
        switch (response.status) {
          case 422:
          if(error.errors.image) {
              this.error.image.status = 'is-invalid';
              this.error.image.message = error.errors.image;
            }
            if(error.errors.name) {
              this.error.name.status = 'is-invalid';
              this.error.name.message = error.errors.name;
            }
            if(error.errors.excerpt) {
              this.error.excerpt.status = 'is-invalid';
              this.error.excerpt.message = error.errors.excerpt;
            }
            if(error.errors.category_id) {
              this.error.category.status = 'is-invalid';
              this.error.category.message = error.errors.category_id;
            }
            break;
        }
      }
    }
  }
</script>